import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const formSlice = createSlice({
  name: "form",
  initialState: {},
  reducers: {
    globalValue: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearGlobalFormData: (state, action) => {
      // مثل clearFormData تو serviceReducer.js، ولی برای another؛ فقط کلیدهای مشخص‌شده رو حذف می‌کنه، نه کل state (که _currentUser رو هم می‌بره)
      const fieldsToRemove = action.payload || [];
      const newState = { ...state };
      fieldsToRemove.forEach((field) => {
        delete newState[field];
      });
      return newState;
    },
    clearFormDataGlobal: () => initialState,
  },
});

export const { clearFormDataGlobal, globalValue, clearGlobalFormData } = formSlice.actions;

export default formSlice.reducer;
